var React = require('react');

function Search2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 10L14 14M11.3333 6.66667C11.3333 9.244 9.244 11.3333 6.66667 11.3333C4.08934 11.3333 2 9.244 2 6.66667C2 4.08934 4.08934 2 6.66667 2C9.244 2 11.3333 4.08934 11.3333 6.66667Z","stroke":"currentColor","strokeWidth":"1.3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Search2.defaultProps = {"id":"search-2","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search2;

Search2.default = Search2;
